import { BaseThemeColors } from './interfaces/baseThemeColors';
import { themeColors } from './themeColors';

export const materialTheme = (colors: BaseThemeColors) => {
  return {
    typography: {
      fontFamily: 'Ambit-Regular, Inter, sans-serif',
    },
    palette: {
      primary: {
        main: colors.primary,
      },
      secondary: {
        main: colors.secondary,
      },
      ...themeColors,
    },
  };
};
